export class OrderItemModel {
  public id: string;
  public menuItemId:	string;
  public quantity: number;
  public orderId: string;
  public venueMenuItemName: string;
  public venueMenuItemPrice: number;
  public venueMenuItemPriceWithTax: number;

}
